import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WalPageService } from '../../../services/session/wal-page.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { HeaderSectionDirective } from '../../../directives/header-section.directive';
import { FooterSectionDirective } from '../../../directives/footer-section.directive';
import { INotificationHistory } from '../../../interfaces/notification/notification-history';
import { ISessionDetails } from '../../../interfaces/session-details';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-notif-log-grid',
    standalone: true,
    templateUrl: './notification-log-grid.component.html',
    styleUrls: ['./notification-log-grid.component.css'],
    imports: [FormsModule]
})
export class NotificationLogGridComponent implements OnInit {

  @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

  notificationHistory!: INotificationHistory[];

    private readonly router = inject(Router);
    private readonly dataExchangeService = inject(DataExchangeService);
    private readonly walPageService = inject(WalPageService);
    private readonly logger = inject(NGXLogger);

    showSeqNum: boolean = true;
    showSentDate: boolean = true;

  constructor()
    {}

  ngOnInit() {
    // Get the parameters from the caller (Walletron)
    let region = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();

    if (region && session) {
      // Retrieve notification history
      this.getNotificationLog(region, session.walPageUuid);
    }
  }

  getNotificationLog(region: string, sessionId: string) {
    this.walPageService.getNotificationLog(region, sessionId)
    .subscribe({
      next: (response) => {
        if (response?.notifList) {
          this.logger.debug('NotificationLogGridComponent - getNotificationLog', response);
          this.notificationHistory = response.notifList;
        }
      },
      error: (error) => {
          this.logger.error('NotificationLogGridComponent - getNotificationLog', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

}
